import AccountReceivableListModal from '@/components/_common/AccountReceivableListModal';
import {
  StatisticDashboardModule,
  StatisticDashboardTypeColor,
} from '@/components/_common/StatisticDashboard';

import { AccountReceivableSituation } from '@/core/domain/financial/AccountReceivable/AccountReceivable.types';
import { useDisclosure } from '@/hooks';
import { DateTimeFormat } from '@/utils/moment';
import moment from 'moment';

import DashboardStatisticCard from '../../DashboardStatisticCard';
import formatterPrice from '@/utils/number/formatterPrice';

interface Props {
  value?: number;
}

function ReceiveToday({ value }: Props) {
  const [viewAccountReceivablesOpen, viewAccountReceivablesActions] =
    useDisclosure();

  return (
    <>
      <DashboardStatisticCard
        tooltipTitle="Valor de parcelas do contas a receber com data de vencimento igual ao dia atual."
        statisticTitle="Parcelas a receber | Dia"
        color={StatisticDashboardTypeColor.income}
        value={formatterPrice(value || 0)}
        module={StatisticDashboardModule.accountReceivable}
        onClick={viewAccountReceivablesActions.open}
      />

      <AccountReceivableListModal
        open={viewAccountReceivablesOpen}
        onCancel={viewAccountReceivablesActions.close}
        queryFilter={{
          situation: AccountReceivableSituation.open,
          dueDate: moment().format(DateTimeFormat),
        }}
      />
    </>
  );
}

export default ReceiveToday;
